export const isElectronApp = () => {
	return navigator.userAgent.includes('BizPrintElectronApp');
};

export const isMacOS = () => {
	return navigator.userAgent.toLocaleLowerCase().includes('macintosh');
};
